"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDatadogRum = void 0;
const browser_rum_1 = require("@datadog/browser-rum");
/**
 * @public
 * Inicializa a funcionalidade de RUM na aplicação.
 */
function useDatadogRum(config) {
    browser_rum_1.datadogRum.init(config);
    return browser_rum_1.datadogRum;
}
exports.useDatadogRum = useDatadogRum;
//# sourceMappingURL=real-user-monitoring.js.map